import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import common from './modules/common';
import auth from './modules/auth';
import message from './modules/message';
import document from './modules/document';
import news from './modules/news';
import member from './modules/member';
import games from './modules/games';
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        common,
        auth,
        message,
        document,
        news,
        member,
        games
    },
    plugins: [createPersistedState({
            storage: window.localStorage,
            reducer(val) {
                return {
                    auth: val.auth
                };
            }
        })]
});
